var map = {
	"./fullreport-green.png": "a284",
	"./fullreport-limited.png": "3c8f",
	"./fullreport-nopart.png": "d8df",
	"./fullreport-yellow.png": "4c8d",
	"./fullreport_down.png": "ee29",
	"./picture.png": "2c6e",
	"./sanfei_bg.png": "3021",
	"./tflogo.png": "3f24"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "070c";